import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'underscore';
import IncidentTable from './IncidentTable';
import { SelectIncidentConfiguration, ToggleIncConfigDialog } from '../../../actions/IncidentTrackerConfigurationActions.js';

const IncidentLayersTable = (props) => {
	const { className, data, ...rest } = props;
	const dispatch = useDispatch();

	const _incConfigDialogOpen = (rowData, mode) => {
		const item = { id: rowData[0], technology: rowData[1], layer: rowData[2] };
		dispatch(SelectIncidentConfiguration({ category: 'layer', item }));
		dispatch(ToggleIncConfigDialog(true, mode));
	};

	const _getTableColumns = () => (
		[
			{
				name: 'technology',
				label: 'Technology',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'layer',
				label: 'Layer',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
		]
	);

	return (
		<IncidentTable
			identifier="incidentLayersTable"
			title="Layers"
			data={data}
			customColumns={_getTableColumns()}
			onDeleteClick={(rowData) => _incConfigDialogOpen(rowData, 'Delete')}
			onEditClick={(rowData) => _incConfigDialogOpen(rowData, 'Update')}
		/>
	);
};

IncidentLayersTable.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default IncidentLayersTable;
